interface IGraphDataPoint {
    y: number | null;
}

interface IGraphDataSeries {
    data?: IGraphDataPoint[];
}

// A real value flanked by null neighbors on both sides has no line/area segment to draw (connectNulls
// is disabled), so it needs its point marker enabled to be visible at all - otherwise it's only
// revealed via the chart's hover-state marker.
export const hasIsolatedDailyPoints = (graphData: IGraphDataSeries[] | undefined): boolean =>
    Boolean(
        graphData?.some((site) =>
            site.data?.some((point, idx, arr) => {
                if (point.y === null || point.y === undefined) {
                    return false;
                }
                const prevY = arr[idx - 1]?.y ?? null;
                const nextY = arr[idx + 1]?.y ?? null;
                return prevY === null && nextY === null;
            }),
        ),
    );
